import { FC } from "react";
import { Book, Props } from "../types";
import { Grid } from "@mui/material";
import { BookComponent } from "../components/RowLibrary";
import { useNavigate } from "react-router-dom";
import { GoBack } from "../components/GoBack";
import { track } from "@amplitude/analytics-browser";

export const Library: FC<Props> = (props) => {
  const { books, setLastBooksRead } = props;
  const navigate = useNavigate();
  const onSelectBook = (book: Book) => {
    setLastBooksRead(book.id);
    track("Library: selected book", book);
    navigate(`/tracker/${book.id}`);
  };
  return (
    <div>
      <GoBack />
      <p className="secctionTitle">my library</p>
      <Grid container>
        {Object.entries(books).map(([key, book]) => {
          return (
            <Grid item xs={6}>
              <BookComponent
                key={book.id}
                book={book}
                onClick={() => {
                  onSelectBook(book);
                }}
              />
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
};
